import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'primeng/carousel';
import { HtmlDecodePipe, SafeEmbedHtmlPipe } from '../../../Common/pipes/Angular-commonUtil.pipe';
import { TruncatePipe } from '../../../Common/pipes/truncate.pipe';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Job } from '../../Models/job.model';
import { A11yModule } from '@angular/cdk/a11y';
import {JobDetailsComponent} from '../job-details/job-details.component';
@Component({
    selector: 'app-jobs-carousel',
    standalone: true,
    imports: [CommonModule, CarouselModule, HtmlDecodePipe, SafeEmbedHtmlPipe, TruncatePipe, TranslateModule, A11yModule],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './jobs-carousel.component.html',
    styleUrls: ['./jobs-carousel.component.scss']
})
export class JobsCarouselComponent implements OnChanges {
    constructor(private renderer: Renderer2, private translateService: TranslateService) {}
    @Input() jobs: any[] = [];
    @Input() pageType: string = 'search';
    @Output() jobDetails = new EventEmitter<any>();

    currentNumVisible = 3;
    page = 0;
    expandedJobIndex: number | null = null;
    parmJob: any;
    private readMoreTriggerElement: HTMLElement | null = null;

    private announce(message: string, isAssertive = false): void {
        const regionId = isAssertive ? 'liveRegionAssertive' : 'liveRegionLoginStatus';
        let region = document.getElementById(regionId) as HTMLElement;
        if (!region) {
            region = document.createElement('div');
            region.id = regionId;
            region.setAttribute('aria-live', isAssertive ? 'assertive' : 'polite');
            region.setAttribute('aria-atomic', 'true');
            region.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;';
            document.body.appendChild(region);
        }
        region.textContent = '';
        setTimeout(() => {
            if (region) {
                region.textContent = message;
            }
        }, 50);
        setTimeout(() => {
            if (region && region.textContent === message) {
                region.textContent = '';
            }
        }, 1000);
    }

    responsiveOptions = [
        {
            breakpoint: '1024px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '768px',
            numVisible: 1,
            numScroll: 1
        }
    ];

    ngOnChanges(changes: SimpleChanges) {
        if (changes['jobs'] && this.jobs) {
            this.currentNumVisible = Math.max(1, Math.min(this.jobs.length, 3));
            this.page = 0;
            // AVT2-9 / AVT3-5: Focus is managed by the parent (JobsMapComponent.scrollToCarousel)
            // which focuses the first job-title link directly. Do not override that here.
        }
    }
    ngAfterViewInit() {
        // Focus management handled by parent component after jobs are loaded.
    }

    isItemVisible(index: number): boolean {
        return index >= this.page && index < this.page + this.currentNumVisible;
    }

    onPageChange(event: any): void {
        this.page = event.page;
        setTimeout(() => {
            const elementId = 'MapJob_' + this.page;
            const element = document.getElementById(elementId);
            if (element) {
                element.focus();
            }
        }, 250);
    }

    displayRenderedFields(questions: any[]): any[] {
        if (!questions) return [];
        return HtmlDecodePipe.displayRenderedFields(questions);
    }

    extractJobFieldsFromQuestions(questions: any[]): any {
        const getValue = (name: string) =>
            questions?.find((q: any) => q.QuestionName === name)?.Value || '';

        return {
            jobtitle: getValue('jobtitle'),
            lastupdated: getValue('lastupdated'),
            autoreq: getValue('autoreq'),
            jobdescription: getValue('jobdescription'),
            companyname: getValue('companyname')
        };
    }

    onJobTitleClickFromMouse(event: MouseEvent, job: any, jobId: string): void {
        this.onJobTitleClick(event, job, jobId);
    }

    onJobTitleClickFromKeyboard(event: Event, job: any, jobId: string): void {
        const keyEvent = event as KeyboardEvent;
        if (keyEvent.key === 'Enter' || keyEvent.key === ' ' || keyEvent.key === 'Spacebar') {
            this.onJobTitleClick(keyEvent, job, jobId);
        }
    }

    private onJobTitleClick(event: MouseEvent | KeyboardEvent, job: any, jobId: string): void {
        if (event instanceof KeyboardEvent && event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
        const appScope = (window as any).appScope;
        appScope.job = job;
        appScope.jobs = this.jobs;
       //if(this.tgsettings.)
        //window.dispatchEvent(new CustomEvent('triggerJobDetailsTitle', {
        //    detail: { scope: appScope, launchJobDetailsOnLoad: false, jobId: jobId }
        //}));
        
         if (appScope?.handlers?.jobTitle) {
             appScope.handlers.jobTitle(appScope, false, jobId);
         } else {
             console.error('jobTitle handler not found on appScope');
         }
    }

    toggleReadMore(index: number, job: any): void {
        this.readMoreTriggerElement = document.activeElement as HTMLElement;
        this.expandedJobIndex = index;
        this.parmJob = job;

        const jobTitle = this.extractJobFieldsFromQuestions(job.Questions).jobtitle || 'Job';
        const modalOpenMsg = `${jobTitle} details card dialogue open`;
        this.announce(modalOpenMsg, true);

        setTimeout(() => {
            const modalTitle = document.getElementById('modalTitle');
            if (modalTitle) {
                modalTitle.focus();
            }
        }, 0);
    }

    closeReadMore(): void {
        const closedIndex = this.expandedJobIndex;
        this.expandedJobIndex = null;
        const dialogTitle = 'Job details card';
        const closedSuffix = this.translateService.instant('Dialog_closed') || 'dialog closed';
        this.announce(`${dialogTitle} ${closedSuffix}`, true);
        setTimeout(() => {
            if (closedIndex !== null) {
                const jobTitleBtn = document.getElementById('MapJob_' + closedIndex);
                if (jobTitleBtn) {
                    jobTitleBtn.focus();
                    this.readMoreTriggerElement = null;
                    return;
                }
            }
            if (this.readMoreTriggerElement && document.body.contains(this.readMoreTriggerElement)) {
                this.readMoreTriggerElement.focus();
            }
            this.readMoreTriggerElement = null;
        }, 350);
    }

    handleClick($event: any, job: any, type: string): void {
        const appScope = (window as any).appScope;
        if (appScope?.ApplyFrmSimilarJobswidget) {
            appScope.ApplyFrmSimilarJobswidget($event, job, type);
        }
    }
    closeCarousel(){
         this.jobs = [];
         
    }
}
